document.addEventListener("DOMContentLoaded", function () {
  const autoplayDelay = 5000; // Tiempo en milisegundos entre cada slide (1000ms = 1 segundos)

  const track = document.querySelector(".home-carousel-track");
  const slides = Array.from(track.querySelectorAll(".home-carousel-slide"));
  const nextButton = document.querySelector(".home-carousel-button-next");
  const prevButton = document.querySelector(".home-carousel-button-prev");
  const pagination = document.querySelector(".home-carousel-pagination");
  const container = document.querySelector(".home-carousel-container");

  let currentIndex = 0;
  let autoplayInterval = null;

  // Crear paginación
  slides.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.classList.add("home-carousel-dot");
    if (index === 0) dot.classList.add("active");
    dot.addEventListener("click", () => {
      goToSlide(index);
      resetAutoplay();
    });
    pagination.appendChild(dot);
  });

  // Actualizar la posición del carrusel
  function updateCarousel() {
    track.style.transform = `translateX(-${currentIndex * 100}%)`;

    // Actualizar paginación
    document.querySelectorAll(".home-carousel-dot").forEach((dot, index) => {
      dot.classList.toggle("active", index === currentIndex);
    });
  }

  // Ir a una diapositiva específica
  function goToSlide(index) {
    currentIndex = index;
    updateCarousel();
  }

  // Ir a la siguiente diapositiva
  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    updateCarousel();
  }

  // Ir a la diapositiva anterior
  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateCarousel();
  }

  // Iniciar autoplay
  function startAutoplay() {
    if (autoplayInterval === null) {
      autoplayInterval = setInterval(nextSlide, autoplayDelay);
    }
  }

  // Detener autoplay
  function stopAutoplay() {
    if (autoplayInterval !== null) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Reiniciar autoplay
  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  // Event listeners para los botones
  nextButton.addEventListener("click", () => {
    nextSlide();
    resetAutoplay();
  });

  prevButton.addEventListener("click", () => {
    prevSlide();
    resetAutoplay();
  });

  // Pausar autoplay al pasar el mouse o tocar
  container.addEventListener("mouseenter", stopAutoplay);
  container.addEventListener("mouseleave", startAutoplay);
  container.addEventListener("touchstart", stopAutoplay);
  container.addEventListener("touchend", startAutoplay);

  // Swipe en móviles
  let touchStartX = 0;
  let touchEndX = 0;

  track.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.changedTouches[0].screenX;
    },
    { passive: true }
  );

  track.addEventListener(
    "touchend",
    (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    },
    { passive: true }
  );

  function handleSwipe() {
    if (touchStartX - touchEndX > 50) {
      nextSlide();
      resetAutoplay();
    } else if (touchEndX - touchStartX > 50) {
      prevSlide();
      resetAutoplay();
    }
  }

  // Iniciar autoplay al cargar
  startAutoplay();
});
